<template>
	<div>
		<!-- vimeo embed -->
		<!-- FIXME: potentially throws .videoURL.includes is not a function  -->
		<template v-if="isVimeoURL(videoURL)">
			<iframe
				class="video"
				:src="`${videoURL}&amp;badge=0&amp;autopause=0&amp;player_id=0&amp;app_id=58479`"
				frameborder="0"
				allow="autoplay; fullscreen; picture-in-picture"
				allowfullscreen
			/>
		</template>
		<!-- generic video fallback -->
		<VideojsPlayer
			v-else
			class="video"
			:options="videoOptions"
		/>
	</div>
</template>

<script lang="ts">
import { defineComponent } from "vue";
import axios from "axios";
import VideojsPlayer from "@/components/Common/VideojsPlayer.vue";
import { monitoringCaptureError } from "@/plugins/monitoring";

type VideoOptions = {
	autoplay: boolean;
	controls: boolean;
	fluid: boolean;
	responsive: boolean;
	sources: { src: string }[];
};

export default defineComponent({
	name: "VideoPlayerComponent",
	components: { VideojsPlayer },
	props: {
		videoURL: { type: String, required: true },
		imageURL: { type: String },
	},
	computed: {
		videoOptions(): VideoOptions {
			return {
				autoplay: true,
				controls: true,
				fluid: true,
				responsive: true,
				sources: [
					{
						src: this.videoURL,
					},
				],
			};
		},
	},
	methods: {
		// Validate if the URL belongs to Vimeo
		isVimeoURL(url: string): boolean {
			try {
				const parsedURL = new URL(url);
				const allowedHosts = ["vimeo.com", "www.vimeo.com"];
				return allowedHosts.includes(parsedURL.hostname);
			} catch {
				// If URL parsing fails, return false
				return false;
			}
		},
		// get the video thumbnail from vimeo link if not provided
		async getVideoThumbnail() {
			if (this.imageURL) {
				return this.imageURL;
				// Validate the video URL against allowed hosts
			} else if (this.isVimeoURL(this.videoURL)) {
				try {
					const videoData = await axios.get(
						"https://vimeo.com/api/oembed.json?url=" + this.videoURL + "&height=720",
					);
					return videoData.data.thumbnail_url;
				} catch (error) {
					monitoringCaptureError(error, "Get video thumbnail");
				}
			}
		},
	},
	mounted() {
		// if (this.videoURL) {
		// 	this.imageURL = this.getVideoThumbnail();
		// }
	},
});
</script>

<style scoped>
.video-container {
}
.video {
	display: block;
	width: 100%;
	object-fit: cover;
	aspect-ratio: 16/9;
}
</style>
